<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Fleet Master</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Class
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span>Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Class Management <span><i class="ic-car"></i></span>
                  </h2>
                  <p>
                    Create and manage vehicle classes to support your business
                    demand.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.row -->
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row hidden">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Phone Number, Provider or Driver Name"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>
                    Name
                    <!-- <span class="button-sort" @click="onClickSort('name')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span> -->
                  </th>
                  <th>
                    Similar Brand
                    <!-- <span class="button-sort" @click="onClickSort('factory')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span> -->
                  </th>
                  <th class="text-left">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td>
                    <span :class="{ 'sts-danger': !item.hasSimilarBrand }">{{
                      printSimilarBrand(item)
                    }}</span>
                  </td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        :disabled="!isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        class="btn btn-default"
                        type="button"
                        @click.prevent="updateItem(item)"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        class="btn btn-default"
                        type="button"
                        @click.prevent="confirmDelete(item)"
                      >
                        <i class="ic-close"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="classmodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Class</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="logo-provider" v-if="model.imageUri">
                      <img :src="model.imageUri" alt="img-class" />
                    </div>
                    <div class="form-group">
                      <label class="required">Class</label>
                      <v-select
                        class="v-search-select"
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.globalClassId.$error,
                        }"
                        placeholder=""
                        label="name"
                        v-model="model.globalClassId"
                        :options="commonClasses"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.id"
                        @input="
                          model.imageUri = getImageUri(model.globalClassId)
                        "
                      >
                      </v-select>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.globalClassId.required"
                        >Class is required</small
                      >
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <label>Manufacturer</label>
                        <div class="row">
                          <div class="col-sm-9">
                            <div class="form-group">
                              <v-select
                                class="v-search-select"
                                placeholder=""
                                label="name"
                                v-model="model.factoryId"
                                :options="factories"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.id"
                                @input="model.brandId = null"
                              ></v-select>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group">
                              <button
                                type="submit"
                                class="btn btn-default"
                                @click.prevent="onClickAddFactory()"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <label>Model</label>
                        <div class="row">
                          <div class="col-sm-9">
                            <div class="form-group">
                              <v-select
                                class="v-search-select"
                                placeholder=""
                                label="name"
                                v-model="model.brandId"
                                :options="filteredBrands"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.id"
                              ></v-select>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div class="form-group">
                              <button
                                type="submit"
                                class="btn btn-default"
                                @click.prevent="onClickAddBrand()"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="model.feature" class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="required">Pax Capacity</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.model.feature.paxCapacity.$error,
                            }"
                            type="number"
                            autocomplete="off"
                            v-model="model.feature.paxCapacity"
                          />
                          <div
                            v-if="
                              isSubmitted && $v.model.feature.paxCapacity.$error
                            "
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.feature.paxCapacity.required"
                              >Pax Capacity is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.feature.paxCapacity.minValue"
                              >Min Pax Capacity is
                              {{
                                $v.model.feature.paxCapacity.$params.minValue
                                  .min
                              }}</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.feature.paxCapacity.maxValue"
                              >Max Pax Capacity is
                              {{
                                $v.model.feature.paxCapacity.$params.maxValue
                                  .max
                              }}</small
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="required">Doors</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.model.feature.doors.$error,
                            }"
                            type="number"
                            autocomplete="off"
                            v-model="model.feature.doors"
                          />
                          <div
                            v-if="isSubmitted && $v.model.feature.doors.$error"
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.feature.doors.required"
                              >Doors is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.feature.doors.minValue"
                              >Min Doors is
                              {{
                                $v.model.feature.doors.$params.minValue.min
                              }}</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.model.feature.doors.maxValue"
                              >Max Doors is
                              {{
                                $v.model.feature.doors.$params.maxValue.max
                              }}</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="model.feature" class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="required">Large Baggage Capacity</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.model.feature.largeBaggageCapacity.$error,
                            }"
                            type="number"
                            autocomplete="off"
                            v-model="model.feature.largeBaggageCapacity"
                          />
                          <div
                            v-if="
                              isSubmitted &&
                              $v.model.feature.largeBaggageCapacity.$error
                            "
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="
                                !$v.model.feature.largeBaggageCapacity.required
                              "
                              >Large Baggage is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="
                                !$v.model.feature.largeBaggageCapacity.minValue
                              "
                              >Min Large Baggage is
                              {{
                                $v.model.feature.largeBaggageCapacity.$params
                                  .minValue.min
                              }}</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="
                                !$v.model.feature.largeBaggageCapacity.maxValue
                              "
                              >Max Large Baggage is
                              {{
                                $v.model.feature.largeBaggageCapacity.$params
                                  .maxValue.max
                              }}</small
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="required">Small Baggage Capacity</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                $v.model.feature.smallBaggageCapacity.$error,
                            }"
                            type="number"
                            autocomplete="off"
                            v-model="model.feature.smallBaggageCapacity"
                          />
                          <div
                            v-if="
                              isSubmitted &&
                              $v.model.feature.smallBaggageCapacity.$error
                            "
                          >
                            <small
                              class="form-text sts-danger"
                              v-if="
                                !$v.model.feature.smallBaggageCapacity.required
                              "
                              >Small Baggage is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="
                                !$v.model.feature.smallBaggageCapacity.minValue
                              "
                              >Min Small Baggage is
                              {{
                                $v.model.feature.smallBaggageCapacity.$params
                                  .minValue.min
                              }}</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="
                                !$v.model.feature.smallBaggageCapacity.maxValue
                              "
                              >Max Small Baggage is
                              {{
                                $v.model.feature.smallBaggageCapacity.$params
                                  .maxValue.max
                              }}</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label class="required"
                            >Upgradable Class (For Amend)</label
                          >
                          <multiselect
                            v-model="model.allowedAmendClass"
                            :options="upgradableClasses"
                            :multiple="true"
                            :close-on-select="false"
                            placeholder="Select Class"
                            label="label"
                            track-by="id"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label class="required"
                            >Upgradable Class (For Dispatch)</label
                          >
                          <multiselect
                            v-model="model.allowedDispatchClass"
                            :options="upgradableClasses"
                            :multiple="true"
                            :close-on-select="false"
                            placeholder="Select Class"
                            label="label"
                            track-by="id"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-if="model.feature">
                      <label class="cursor-pointer w-max-content">
                        <input
                          type="checkbox"
                          class="control-checkbox"
                          v-model="model.feature.hasAirConditioning"
                        />
                        <span class="pl-5 font-weight-normal v-align-middle">
                          Air Conditioning
                        </span>
                      </label>
                    </div>
                    <div class="form-group">
                      <label class="required">Operation</label>
                      <div class="d-flex">
                        <label
                          class="cursor-pointer"
                          v-for="(item, index) in operations"
                          :key="index"
                          :class="{ 'pl-20': index > 0 }"
                        >
                          <input
                            type="checkbox"
                            class="control-checkbox"
                            :value="item.text"
                            v-model="model.operations"
                          />
                          <span class="pl-5 font-weight-normal v-align-middle">
                            {{ humanize(item.text) }}
                          </span>
                        </label>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import masterFactoryService from "@/services/master/masterFactoryService.js";
import masterBrandService from "@/services/master/masterBrandService.js";
import masterClassService from "@/services/master/class/masterClassService.js";
import vehicleService from "@/services/master/vehicle/vehicleService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    filteredBrands: function () {
      return this.brands.filter((brand) => {
        return brand.vehicleFactory.id === this.model.factoryId;
      });
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
      },
      isSubmitted: false,
      allPermissions: [],
      isUpdate: false,
      items: [],
      commonClasses: [],
      upgradableClasses: [],
      operations: [],
      factories: [],
      brands: [],
      model: {},
      itemToBeDeleted: null,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        globalClassId: { required },
        feature: {
          paxCapacity: {
            required,
            minValue: minValue(1),
            maxValue: maxValue(100),
          },
          doors: { required, minValue: minValue(1), maxValue: maxValue(6) },
          largeBaggageCapacity: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(100),
          },
          smallBaggageCapacity: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(100),
          },
        },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getCommon();
      await this.getMasterFactories();
      await this.getMasterBrands();
    }
  },
  updated() {
    this.$helper.collapseMenu("fleet-master");
    this.$helper.setNavigationClass("masterclass-link");
  },
  mounted() {
    $(this.$refs.classmodal).on("hidden.bs.modal", this.closeModal);
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async onClickSort(column) {
      if (this.table.sort === column) {
        this.table.sortDir = this.table.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.table.sortDir = "asc";
      }
      this.table.sort = column;
      await this.getAll();
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        if (this.table.sort && this.table.sort !== "") {
          filter += `&sort=${this.table.sort}&sortDir=${this.table.sortDir}`;
        }
        const response = await masterClassService.getAll(filter);

        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;

        for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i];
          item.hasSimilarBrand =
            (item.factoryName && item.factoryName !== "") ||
            (item.brandName && item.brandName !== "");
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCommon() {
      const response = await masterClassService.getAllCommon();
      const vehicleCommon = await vehicleService.getCommon();
      this.operations = vehicleCommon.operations;
      if (response) {
        this.commonClasses = response;
        this.upgradableClasses = response.map((item) => ({
          ...item,
          label: item.name,
        }));
      }
    },
    async getMasterFactories() {
      this.factories = await masterFactoryService.getAll();
    },
    async getMasterBrands() {
      this.brands = await masterBrandService.getAll();
    },
    async onClickAddFactory() {
      const newFactoryName = prompt("Please enter new manufacturer name:", "");
      if (newFactoryName && newFactoryName !== "") {
        try {
          await masterFactoryService.create({
            name: newFactoryName,
          });
          await this.getMasterFactories();
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        } catch (error) {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        }
      }
    },
    async onClickAddBrand() {
      const newBrandName = prompt("Please enter new model name:", "");
      if (newBrandName && newBrandName !== "" && this.model.factoryId) {
        try {
          await masterBrandService.create({
            factoryId: this.model.factoryId,
            name: newBrandName,
          });
          await this.getMasterBrands();
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        } catch (error) {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        }
      }
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal(object) {
      this.resetValidations();
      const dataUpgradeableClasses = [];
      const dataUpgradeableClassesForDispatch = [];
      for (let i = 0; i < object.allowedAmendClass.length; i++) {
        const findClasses = this.upgradableClasses.find(
          (val) => val.id === object.allowedAmendClass[i]
        );
        if (findClasses) {
          dataUpgradeableClasses.push(findClasses);
        }
      }
      for (let i = 0; i < object.allowedDispatchClass.length; i++) {
        const findClasses = this.upgradableClasses.find(
          (val) => val.id === object.allowedDispatchClass[i]
        );
        if (findClasses) {
          dataUpgradeableClassesForDispatch.push(findClasses);
        }
      }
      object.allowedAmendClass = dataUpgradeableClasses;
      object.allowedDispatchClass = dataUpgradeableClassesForDispatch;
      this.model = Object.assign({}, object);
      $(this.$refs.classmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      if (this.isUpdate) {
        const cekItems = this.items.find((val) => val.id === this.model.id);

        if (cekItems) {
          cekItems.allowedAmendClass = cekItems.allowedAmendClass.map(
            (el) => el.id
          );
        }
      }
      this.resetValidations();
      this.model = {};
      $(this.$refs.classmodal).modal("hide");
    },
    createItem() {
      this.isUpdate = false;
      this.openModal({
        allowedAmendClass: [],
        allowedDispatchClass: [],
        globalClassId: null,
        imageUri: null,
        brandId: null,
        isActive: true,
        operations: ["WithDriver", "SelfDrive"],
        feature: {
          doors: 4,
          hasAirConditioning: true,
          largeBaggageCapacity: 1,
          smallBaggageCapacity: 1,
          paxCapacity: 4,
        },
      });
    },
    updateItem(item) {
      this.isUpdate = true;
      this.openModal(item);
      this.model.imageUri = this.getImageUri(this.model.globalClassId);
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        if (!this.model.factoryId || this.model.factoryId === "") {
          delete this.model.factoryId;
          delete this.model.brandId;
        } else if (!this.model.brandId || this.model.brandId === "") {
          delete this.model.brandId;
        }

        this.model.feature.doors = parseInt(this.model.feature.doors);
        this.model.feature.paxCapacity = parseInt(
          this.model.feature.paxCapacity
        );
        this.model.feature.smallBaggageCapacity = parseInt(
          this.model.feature.smallBaggageCapacity
        );
        this.model.feature.largeBaggageCapacity = parseInt(
          this.model.feature.largeBaggageCapacity
        );
        this.model.allowedAmendClass = this.model.allowedAmendClass.map(
          (val) => val.id
        );
        this.model.allowedDispatchClass = this.model.allowedDispatchClass.map(
          (val) => val.id
        );

        if (this.isUpdate) {
          await masterClassService.update(this.model);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          let response = await masterClassService.create(this.model);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        this.model = {};
        await this.getAll();
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await masterClassService.update(item);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.resetValidations();
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await masterClassService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printSimilarBrand(item) {
      let result = "";
      if (item.factoryName && item.factoryName !== "") {
        result += item.factoryName;
      }
      if (item.brandName && item.brandName !== "") {
        result += ` ${item.brandName}`;
      }
      return result !== "" ? result : "N/A";
    },
    getImageUri(globalClassId) {
      const globalClass = this.commonClasses.find(
        (x) => x.id === globalClassId
      );
      return globalClass ? globalClass.imageUri : "";
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/class/MasterClass.vue